import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { mealReservationService } from "../services/mealReservation.service";

export const processWalkIn = createAsyncThunk(
  "mealReservation/processWalkIn",
  async (payload, { rejectWithValue }) => {
    try {
      return await mealReservationService.walkInSale(payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Walk-in failed",
      );
    }
  },
);

const mealReservationSlice = createSlice({
  name: "mealReservation",
  initialState: { loading: false, error: null, lastWalkIn: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(processWalkIn.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(processWalkIn.fulfilled, (s, a) => {
        s.loading = false;
        s.lastWalkIn = a.payload;
      })
      .addCase(processWalkIn.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      });
  },
});

export default mealReservationSlice.reducer;
